module.exports = __webpack_public_path__ + "static/media/rappi logo.cdd72b2a.png";